import React from 'react'
import './professional-card.css'

const ProfessionalCard = ({Action, Professional, Rule, Description, Tags, URLPicture }) => {
    return (
        <div>
            <button className='professional-card' onClick={Action}>

                <span className="check">✓</span>
                <span className="uncheck"></span>

                <div className="icon">
                    <img src={URLPicture} alt="Serviço" />
                </div>

                <div className="content">
                    <p className='professional-name app-little-title'>{Professional}</p>
                    <p className='professional-rule app-text'>{Rule}</p>
                    <p className='professional-description app-little-text'>{Description}</p>
                    <div className="professional-tags-container">
                        <span className='professional-tag app-little-text'>{Tags}</span>
                        <span className='professional-tag app-little-text'>{Tags}</span>
                    </div>
                </div>
            </button>
        </div>
    )
}

export default ProfessionalCard